module.exports = {};


//////////////////
// WEBPACK FOOTER
// /Users/luca/dev/lucagarbin/mascioni.it/~/core-js/modules/_iterators.js
// module id = 46
// module chunks = 0